import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import Heading from 'styles/typography/Heading';

export const MagazinesWrapper = styled.div`
  & .spinning-loader {
    margin: auto;
  }

  & .load-more {
    display: block;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 24px;
  }
`;

export const Header = styled(Heading)`
  margin: 24px 16px 40px 16px;

  @media (${breakpoint.smMin}) {
    margin: 32px 16px 20px;
  }

  @media (${breakpoint.mdMin}) {
    margin: 48px 0 24px 0;
  }
`;

export const MagazinesGridLayout = styled.div`
  display: grid;
  grid-template-areas: "articles sidebar"
                        "button";
  grid-template-columns: 75fr 25fr;

  @media (${breakpoint.hybridMax}) {
    grid-template-columns: 100fr;
  }
`;

export const MagazineSideBar = styled.div`
  margin-left: 48px;
  display: flex;
  flex-direction: column;
  gap: 48px;

  @media (${breakpoint.hybridMax}) {
    display: none;
    margin-left: 0;
  }
`;

export const MagazineContent = styled.div`
  .simple {
    margin-bottom: 30px;
  }
`;
